import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>
        &copy; Michal Codes{' '}
        <a
          href="https://twitter.com/devdevmajki"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-twitter-square" aria-hidden="true" />
        </a>{' '}
        2019
      </p>
    </footer>
  );
};

export default Footer;
